import type { LoginResponse, RegisterRequest } from '@/entities/user';
import { TOKEN_KEY, apiClient } from '@/shared/api/api-client';
import type { ApiResponse } from '@/shared/api/types';
import Cookies from 'js-cookie';

export const authApi = {
  login: async (identifier: string, password: string): Promise<LoginResponse> => {
    // Detect if identifier is email or username
    const isEmail = identifier.includes('@');
    const payload = isEmail ? { email: identifier, password } : { username: identifier, password };

    const response = await apiClient.post<ApiResponse<LoginResponse>>('/v1/public/login', payload);
    const { token } = response.data.data;
    Cookies.set(TOKEN_KEY, token, { expires: 7 });
    return response.data.data;
  },

  register: async (data: RegisterRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<ApiResponse<LoginResponse>>('/v1/public/register', data);
    const { token } = response.data.data;
    Cookies.set(TOKEN_KEY, token, { expires: 7 });
    return response.data.data;
  },

  logout: () => {
    Cookies.remove(TOKEN_KEY);
  },

  refreshToken: async (): Promise<string> => {
    const response = await apiClient.post<ApiResponse<{ token: string }>>('/v1/auth/refresh');
    const { token } = response.data.data;
    Cookies.set(TOKEN_KEY, token, { expires: 7 });
    return token;
  },

  forgotPassword: async (email: string): Promise<void> => {
    await apiClient.post('/v1/public/password/forgot', { email });
  },

  resetPassword: async (token: string, password: string): Promise<void> => {
    await apiClient.post('/v1/public/password/reset', { token, password });
  },

  getToken: (): string | undefined => {
    return Cookies.get(TOKEN_KEY);
  },

  isAuthenticated: (): boolean => {
    return !!Cookies.get(TOKEN_KEY);
  },
};
